import React from 'react';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { useRequestData } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { trackEvent } from 'ddc-track-event';
import ConditionalWrapper from './ConditionalWrapper';

const Callout = ({ callouts, isTabbedLayout }) => {
	const { widgetName, windowId } = useRequestData();
	const badgeName = 'vehicle-card-badge';

	const calloutItems = [];

	calloutItems.push(
		...callouts.map(
			({
				imageSrc,
				imageAlt,
				imageTitle,
				badgeClasses,
				href = null,
				target = null,
				tooltip = ''
			}) => {
				const img = (
					<img src={imageSrc} alt={imageAlt} title={imageTitle} />
				);

				const hasTooltip = !!tooltip && typeof tooltip === 'string';
				const tooltipMarkup = (
					<Popover id="popover">
						<span dangerouslySetInnerHTML={{ __html: tooltip }} />
					</Popover>
				);

				const decodedHref =
					href !== null ? href.replace(/&amp;/g, '&') : '';

				const markup = href ? (
					<a
						href={decodedHref}
						className={setClassNames([...badgeClasses])}
						target={target}
						onClick={() =>
							trackEvent(widgetName, windowId, {
								element: 'Badge button',
								elementCTA: imageTitle
							})
						}
						rel={href.startsWith('http') ? 'nofollow' : undefined}
					>
						{img}
					</a>
				) : (
					img
				);

				return (
					<li
						key={imageTitle}
						className={setClassNames([
							badgeName,
							...badgeClasses,
							'm-2',
							'py-3'
						])}
					>
						<ConditionalWrapper
							condition={hasTooltip}
							wrapper={children => (
								<OverlayTrigger
									placement="top"
									overlay={tooltipMarkup}
								>
									{children}
								</OverlayTrigger>
							)}
						>
							{markup}
						</ConditionalWrapper>
					</li>
				);
			}
		)
	);

	const badgeWrapperClasses = [
		'list-unstyled',
		'd-flex',
		'flex-wrap',
		'justify-content-center'
	];

	if (calloutItems.length === 0) {
		badgeWrapperClasses.push('hidden');
	}

	return (
		<div className="badge-callout">
			<ul
				className={setClassNames(badgeWrapperClasses)}
				data-location={
					isTabbedLayout
						? 'vehicle-badge'
						: 'vehicle-media vehicle-badge'
				}
			>
				{calloutItems}
			</ul>
		</div>
	);
};

Callout.propTypes = {
	callouts: PropTypes.arrayOf(PropTypes.shape({})),
	isTabbedLayout: PropTypes.bool
};

Callout.defaultProps = {
	callouts: [],
	isTabbedLayout: false
};

export default Callout;
